import { useTranslation } from 'react-i18next'

import styles from './StatementsHeader.module.scss'

const StatementsHeader = ({ filters, setFilters, statusOptions }) => {
  const { t } = useTranslation('common')

  return (
    <div className={`unv-card ${styles.header}`}>
      <div className={styles.titleRow}>
        <h1 className={styles.title}>{t('statementsPage.statementsList')}</h1>
      </div>
      <div className={styles.filters}>
        <label className={styles.field}>
          <span className={styles.label}>{t('statementsPage.semester')}</span>
          <input
            className="unv-input"
            placeholder={t('statementsPage.semester')}
            value={filters.semester}
            onChange={(e) => setFilters({ ...filters, semester: e.target.value })}
          />
        </label>
        <label className={styles.field}>
          <span className={styles.label}>{t('statementsPage.groupId')}</span>
          <input
            className="unv-input"
            placeholder={t('statementsPage.groupId')}
            value={filters.group}
            onChange={(e) => setFilters({ ...filters, group: e.target.value })}
          />
        </label>
        <label className={styles.field}>
          <span className={styles.label}>{t('statementsPage.subjectId')}</span>
          <input
            className="unv-input"
            placeholder={t('statementsPage.subjectId')}
            value={filters.subject}
            onChange={(e) => setFilters({ ...filters, subject: e.target.value })}
          />
        </label>
        <label className={styles.field}>
          <span className={styles.label}>{t('statementsPage.status', 'Статус')}</span>
          <select
            className="unv-input"
            value={filters.status}
            onChange={(e) => setFilters({ ...filters, status: e.target.value })}
          >
            {statusOptions.map((s) => (
              <option key={s.key} value={s.key}>{s.label}</option>
            ))}
          </select>
        </label>
      </div>
    </div>
  )
}

export default StatementsHeader
